import { useState, useEffect } from 'react';
import { HostBackend } from '../../../../Routes/HostBackend.js';
/* document */
import { Select } from '../../Form/Inputs/Select.js';
import { Text } from '../../Form/Inputs/Text.js';
import { Date } from '../../Form/Inputs/Date.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const Univers = (props) => {
    const { el } = props;
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const [choosers, setChoosers] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasChoosers = await fetch(`${backend}/admin/choosers/univers`, {
                method: 'GET', headers: { 'Authorization': token, 'Content-Type': 'application/json' }
            });
            const choosers = await datasChoosers.json();
            setChoosers(choosers);
        };
        fetchData();
    }, [backend, token]);
    return (
        <>
            <Select name="id_park" choosers={choosers.parks} value={el ? el.id_park : ''} />
            <Text name="name" value={el ? el.name : ''} />
            <Text name="slug" value={el ? el.slug : ''} />
            <Text name="route" value={el ? el.route : ''} />
            <Date name="created" value={el ? el.created : ''} />
            <Text name="author" value={el ? el.author : ''} />
            <Select name="id_description" choosers={choosers.describe} value={el ? el.id_description : ''} />
            <Hidden name="id" value={el ? el.id : ''} />
        </>
    )
}